import { javantApi } from "../constants";

export const PartnershipPageService = {
    sendForm(data){
        return javantApi.post(`contact/submit`, data);
    }
}